import type { ConnectorOauthExtraConfigProps } from "@app/lib/connector_providers_ui";
import { isValidZendeskSubdomain } from "@app/types/oauth/lib";
import { Input } from "@dust-tt/sparkle";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function ZendeskOAuthExtraConfig({
  extraConfig,
  setExtraConfig,
  setIsExtraConfigValid,
}: ConnectorOauthExtraConfigProps) {
  const { t } = useTranslation();
  useEffect(() => {
    setIsExtraConfigValid(
      isValidZendeskSubdomain(extraConfig.zendesk_subdomain)
    );
  }, [extraConfig, setIsExtraConfigValid]);

  return (
    <Input
      label={t(
        "spaces.zendeskAccountSubdomainLabel",
        "Zendesk account subdomain"
      )}
      message={t(
        "spaces.zendeskSubdomainHelp",
        "The first part of your Zendesk account URL."
      )}
      messageStatus="info"
      name="subdomain"
      placeholder="my-subdomain"
      onChange={(e) => {
        setExtraConfig({ zendesk_subdomain: e.target.value });
      }}
    />
  );
}
